import { merge } from '@fluentui/react';
// Automation topics (things like "your bounty email was sent")
/**
 * Helper enum only for *researcher portal automated/readonly* message topics.
 */
export var MessageTopicAutomated;
(function (MessageTopicAutomated) {
    MessageTopicAutomated["AutoNotification"] = "AutoNotification";
    MessageTopicAutomated["EmailCommunication"] = "EmailCommunication";
})(MessageTopicAutomated || (MessageTopicAutomated = {}));
/**
 * API enum that represents **only** automated message topics.
 *
 * > You probably want:
 * > - For user inputs: `metaMessageTopicOptions`
 * > - For UI rendering: `metaMessageTopic`
 */
export const metaMessageTopicAutomatedOptions = {
    AutoNotification: {
        displayName: 'Auto-notification',
    },
    EmailCommunication: {
        displayName: 'Email communication',
    },
};
// User selectable topics (things like "I have a question about my bounty")
/**
 * Helper enum only for *researcher portal user selectable* message topics.
 */
export var MessageTopicResearcherOption;
(function (MessageTopicResearcherOption) {
    MessageTopicResearcherOption["Assessment"] = "Assessment";
    MessageTopicResearcherOption["CaseStatus"] = "CaseStatus";
    MessageTopicResearcherOption["Release"] = "Release";
    MessageTopicResearcherOption["Bounty"] = "Bounty";
    MessageTopicResearcherOption["Other"] = "Other";
})(MessageTopicResearcherOption || (MessageTopicResearcherOption = {}));
/**
 * API enum for researcher selectable message topics.
 *
 * > You probably want:
 * > - For user inputs: `metaMessageTopicResearcherOptions`
 * > - For UI rendering: `metaMessageTopic`
 */
export const metaMessageTopicResearcherOptions = {
    Assessment: {
        displayName: 'Assessment',
        order: 0,
    },
    CaseStatus: {
        displayName: 'Case Status',
        order: 1,
    },
    Release: {
        displayName: 'Release',
        order: 2,
    },
    Bounty: {
        displayName: 'Bounty',
        order: 3,
    },
    Other: {
        displayName: 'Other',
        order: 4,
    },
};
/**
 * Helper enum for *all possible* message topics.
 */
export const MessageTopic = Object.assign(Object.assign({}, MessageTopicAutomated), MessageTopicResearcherOption);
/**
 * API enum data for all possible renderable message topics.
 *
 * @example
 * const impact = metaMessageTopic[message.topic]?.displayName;
 *
 * Source: https://msrceng.visualstudio.com/Workflows/_git/Antimatter-Services?path=%2Fsrc%2FCommsHub%2FMicrosoft.Msrc.CommsHub.Models%2FEnum%2FTopic.cs
 */
export const metaMessageTopic = merge({}, metaMessageTopicAutomatedOptions, metaMessageTopicResearcherOptions);
/**
 * Accepts a message topic key and returns its display name or
 * attempts to return the key if no display name is found.
 */
export const getMessageTopicName = (topic) => { var _a; return ((_a = metaMessageTopic[topic]) === null || _a === void 0 ? void 0 : _a.displayName) || topic; };
